import axios from 'axios'
import {setLocalValue, removeLocalValue, getQueryStringByName, isEmpty, getLoginUrl} from '@/utils/commonUtil'
import wx from 'weixin-jsapi'
import {getLocalValue} from '../../utils/commonUtil'
// import router from '../../router'

export async function authLogin () {
  await localAuthLogin()
  await UserJobNumber()
  await wxAuthLogin()
  await getCurrentUser()
  await getCurrentUserRoles()
  // wxAuthConfig(false, 0)
}

// 本地登录接口-模拟登陆
export async function localAuthLogin () {
  removeLocalValue('token')
  removeLocalValue('expires')
  let url = `${getLoginUrl()}/login/${process.env.LOGIN_URL_ID}/oauth2/token`
  let formData = new FormData()
  formData.append('client_id', process.env.CRM_Client_ID)
  formData.append('client_secret', process.env.CLIENT_SECRET)
  formData.append('resource', process.env.RESOURCE)
  formData.append('grant_type', process.env.GRANT_TYPE)
  let config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    timeout: 20000,
  }
  try {
    const res = await axios.post(url, formData, config)
    setLocalValue('token', res.data.access_token)
    // 记录token失效的时间，提前三分钟获取新的token
    setLocalValue('expires', new Date().getTime() + (res.data.expires_in - 180) * 1000)
    console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^')
    console.log(getLocalValue('expires'))
  } catch (err) {
    console.log(JSON.stringify(err))
    return err
  }
}
// 获取用户工号
export async function UserJobNumber () {
  let username = getLocalValue('username')
  let params = {
    domainname: username,
  }
  await $appForm
    .getStaffnumber(params)
    .then((res) => {
      console.log(res.data.outputresult.toString())
      setLocalValue('userId', res.data.outputresult.toString())
    })
}
// 企业微信登陆
export async function wxAuthLogin () {
  removeLocalValue('VXUserJobNumber')
  const code = getQueryStringByName('code')
  console.log('code: ', code)
  if(isEmpty(code)) {
    return
  }
  await $appForm
    .hdAuth(code)
    .then((res) => {
      let resData = res.data || {}
      if(resData.code === '10') {
        let dataJson = resData.result ? JSON.parse(resData.result) : {}
        console.log(dataJson)
        // 获取企业微信绑定的员工工号
        setLocalValue('VXUserJobNumber', dataJson.UserId)
      } else {
        console.error(resData)

        // // 发布正式包要注释掉
        // if(process.env.NODE_ENV === 'development') {
        //   setLocalValue('userId', 'hand005')
        // }
      }
      getCurrentUser()
      // getCurrentUserRoles()
    })
    .catch((err) => {
      console.error(err)
      // setLocalValue('userId', 'hand002')
    })
}
// 企业微信config
export async function wxAuthConfig (refresh, count) {
  console.log(wx, '<---wx')
  let url = window.location.href
  // let url = 'https://crmuat-app.hitachi-helc.com/index.html?code=TLvP2NuLhcZTeGjruoKaMsWm0OMzkR-1Hl6lcAIGOJk&state=#/entry'
  // 防止页面url增加#字符串
  if(url.indexOf('#')) {
    url = url.split('#')[0]
  }
  console.log('url是：', url)
  const res = await $appForm.getSignature(url)
  let resData = res.data || {}
  const wxParams = resData.result ? JSON.parse(resData.result) : {}
  const configOption = {
    beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: wxParams.appId, // 必填，企业微信的corpID
    timestamp: wxParams.timestamp, // 必填，生成签名的时间戳
    nonceStr: wxParams.nonceStr, // 必填，生成签名的随机串
    signature: wxParams.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
    jsApiList: [ // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
      'closeWindow',
      'openLocation',
      'getLocation',
      'hideOptionMenu',
      // 'chooseImage',
      // 'previewImage',
      // 'getLocalImgData',
      // 'uploadImage',
    ],
  }
  initWxConfig(refresh, count, configOption)
  // console.log('configOption-->', configOption)
  // 微信权限注入
  // wx.config(configOption)
  // wx.ready(function () {
  //   // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
  //   console.log('微信JSDK注入成功.....')
  // })
  // wx.error(function (res) {
  //   console.error(res)
  //   console.error('count: ', count)
  //   // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
  //   // console.log('微信JSDK注入失败.....')
  //   // count++
  //   // console.log(res)
  //   if(count < 3) {
  //     count++
  //     wxAuthConfig(true, count)
  //   } else {
  //     console.log(`${count}微信JSDK注入失败.....`)
  //     window.vm.$toast.show({
  //       type: 'error',
  //       content: '微信JSDK注入失败',
  //     })
  //   }
  // })
}
// 微信jssdk权限注入
function initWxConfig (refresh, count, configOption) {
  wx.config(configOption)
  wx.ready(function () {
    // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
    // console.log('微信JSDK注入成功.....')
    console.log('==wx.ready==')
    wx.hideOptionMenu()
  })
  wx.error(function (res) {
    console.error(res)
    console.error('count: ', count)
    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    // console.log('微信JSDK注入失败.....')
    // count++
    // console.log(res)
    if(count < 3) {
      count++
      initWxConfig(true, count, configOption)
    } else {
      console.log(`${count}微信JSDK注入失败.....`)
      // window.vm.$toast.show({
      //   type: 'error',
      //   content: '微信JSDK注入失败',
      // })
    }
  })
}
// 获取当前用户
export async function getCurrentUser () {
  let res = await $appForm.hdForm({tcode: 'getuserinfo'})
  let resData = res.data || {}
  let data = resData.result ? JSON.parse(resData.result) : {}
  setLocalValue('currentUserInfo', data)
}
// 获取当前用户角色列表
export async function getCurrentUserRoles () {
  let res = await $appForm.hdList({tcode: 'userroles'})
  let resData = res.data || {}
  let data = resData.result ? JSON.parse(resData.result) : []
  setLocalValue('currentUserRoles', data)
}



// WEBPACK FOOTER //
// ./src/service/auth/loginService.js